import React, { useContext, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CartContext } from "./CartContext";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const state = searchParams.get("state");
  const isSuccess = state === "success";
  const { clearCart } = useContext(CartContext);
  const cartCleared = useRef(false);

  useEffect(() => {
    if (isSuccess && !cartCleared.current) {
      cartCleared.current = true;
      clearCart();
    }
  }, [isSuccess, clearCart]);

  return (
    <>
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className={`checkmark-circle ${isSuccess ? "" : "is-cancel"}`}>
              <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
            </div>
            <h1>{isSuccess ? "Payment received" : "Payment cancelled"}</h1>
            <p>
              {isSuccess
                ? "Thank you. Your payment was returned successfully and your order is being reviewed."
                : "No payment confirmation was received. Your cart has been kept so you can try again."}
            </p>
            <Link to={isSuccess ? "/shop" : "/checkout"}>
              {isSuccess ? "Continue shopping" : "Return to checkout"}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySuccess;
